import React from 'react'

const Checkbox = React.forwardRef((props, ref) => (
  <label className={props.className || 'region-label'}>
    <input type='checkbox' className='region-control' {...props} ref={ref} />
    {props.label}
  </label>
))

export default Checkbox
